import { Link } from "@StarberryUtils";
import React,{useEffect, useState} from "react";
import { useStaticQuery, graphql } from "gatsby";
import {Col, Row, Container, Tabs, Tab } from 'react-bootstrap';
import  "../Similar.scss";
import Slider from 'react-slick';
import axios from 'axios';
import ImageTransform from "../../../common/ggfx-client/module/components/image-transform";
import ComingSoonImage from "../../../../images/coming-soon.jpg";

import FloorPlanModal from "../../../property-search/floorPlanModal";

import { motion } from "framer-motion";

const contentItem = {
  hidden: { opacity: 0, y: 30 },
  visible: (custom) => ({
      opacity: 1,
      y: 0,
      transition: {
          delay: custom * 0.2,
          duration: 0.4,
          ease: [0.33, 1, 0.68, 1],
      }
  })
}

const strapiconfig = {
  headers: {
      Authorization:
          `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
  },
}

const LetPropSlider = (props) => {

    
	
	const data = useStaticQuery(graphql`
	query{
	  strapidata {
      properties(
        where: {department: "residential", publish: true, status: "Let"}
        sort: "createdAt:DESC"
        limit: 10
      ) {
        search_type
        id
        crm_id
        price
        price_qualifier
        slug
        display_address
        _id
        images
        imagetransforms
        floorplan
        title
      }
    }
	}
  `);
  

	const propertyList = props.landtag == "landing" ? data?.strapidata?.properties : props.LetData;

        const addingClass = (e) =>{
        let lexicalE = e.persist();
                let dm = document.getElementsByClassName("active-map")
                // console.log("testing",dm)
                if(dm.length ==0 ) {
                 if(document.querySelector('.active-map')!==null){
                    document.querySelector('.active-map').classList.remove('active-map')
                    e.target.classList.add("active-map")                    
            }
                    e.target.classList.add("active-map")
                    
                } else {

               document.querySelector('.active-map').classList.remove('active-map')
        }
            // console.log("test",e.target.className ,dm)
    }

  // const [propItems, setPropItems] = useState(false)
  // const getitems = async url => {
  //   try {
  //     const { data } = await axios.get(url, strapiconfig)
  //     setPropItems(data)
  //   } catch (error) {
  //     console.error(error)
  //   }
  // }

  // useEffect(() => {
  //   let officeId = props.officeId ?? "";
  //   let area = props.area ?? "";
  //   let landtag = props.landtag ?? "";

  //   let url = process.env.GATSBY_STRAPI_SRC + (area !== "Commercial" ? "/properties?department=residential&status=Let&_limit=10&_sort=createdAt:DESC&publish=true" : "/properties?department=commercial&status=Let&_limit=10&_sort=createdAt:DESC&publish=true");

  //   if (area && landtag != "landing") {
  //     if(area !== "Commercial") {
  //       url = url + "&display_address_contains=" + area;
  //     }
  //   }
  //   if (officeId) {
  //     url = url + "&office_crm_id=" + officeId;
  //   }

  //   getitems(url)
  // },[])



    const settings =  {
        dots: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: propertyList && propertyList.length > 4,
        arrows: false,
        autoplay:true,
        
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
      const settings2 = {
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        mobileFirst:true,
        responsive: [
          {
            breakpoint: 767,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                }
          },
          {
              breakpoint: 9999,
              settings: "unslick"
          }
          
      ]
      }

    return (
    <>
        {propertyList && propertyList.length ?
        
        <Slider className="property-slider"  {...settings} >
            {propertyList && propertyList.map((item, index) => { 
                // property details url structure
                let uriStr = "";

                if( item.search_type === "sales" ) {
                  uriStr = `property-for-sale/`
                } else if ( item.search_type === "lettings" ) {
                  uriStr = `property-to-rent/`
                }

                if (props.tag == "commercial") {
                  if( item.search_type === "sales" ) {
                    uriStr = `commercial-property-for-sale/`
                  } else if ( item.search_type === "lettings" ) {
                    uriStr = `commercial-property-to-rent/`
                  }
                }

                if (props.tag == "new-homes") {
                  if( item.search_type === "sales" ) {
                    uriStr = `new-homes-for-sale/`
                  } else if ( item.search_type === "lettings" ) {
                    uriStr = `new-homes-to-rent/`
                  }
                }
                // property details url structure

            let processedImages = JSON.stringify({});
            if (item?.imagetransforms?.images_Transforms) {
                processedImages = item.imagetransforms.images_Transforms;
            }
            let processedImagesFloorplan = JSON.stringify({});
            if (item?.imagetransforms?.floorplan_Transforms) {
                processedImagesFloorplan = item.imagetransforms.floorplan_Transforms;
            }
            return (
            <motion.div className="slide-item" variants={contentItem} custom={index} key={index}>
            <div className="similar-property-card d-md-flex flex-wrap"  >
                <div className="view-part1">
                          <Slider className="main-slider" {...settings2} >
                              <div className="main-item">
                                  <Link to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                    {item.images.length != 0 ?
                                    (item.images[0].hd_url ? <img src={item.images[0].hd_url} alt={`${item.display_address}+  - Martyn Gerrard`} /> :
                                    <ImageTransform imagesources={item.images[0].url} renderer="srcSet" imagename="property.images.similar_properties" attr={{ alt: item.display_address+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={item._id}/>) :
                                      <img loading="lazy" src={ComingSoonImage} alt={`${item.display_address} - Martyn Gerrard`} />
                                    }
                                  </Link>
                                  <div className="on-map d-flex">
                                      <a href={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()+'?id=propertymap'} onClick={e=>addingClass(e)}><i className="icon-location"></i> <span className="exp-txt text-uppercase">View on Map</span></a>
                                      {/* <Link to="#"><i className="icon-map-view"></i></Link> */}
                                      {(item.floorplan ? ((item.floorplan.length > 0) ? <FloorPlanModal processedImagesFloorplan={processedImagesFloorplan} floorplanimg={item.floorplan[0].hd_url || item.floorplan[0].url} /> : ''):'')}
                                  </div>
                              </div>
                              <div className="main-item d-md-none">
                                  <Link to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                    {item.images.length > 1 ?
                                    (item.images[1].hd_url ? <img src={item.images[1].hd_url} alt={`${item.display_address}+  - Martyn Gerrard`}/> : 
                                    <ImageTransform imagesources={item.images[1].url} renderer="srcSet" imagename="property.images.similar_properties" attr={{ alt: item.display_address+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={item._id}/>) :
                                      <img loading="lazy" src={ComingSoonImage} alt={`${item.display_address} - Martyn Gerrard`} />
                                    }
                                  </Link>
                                  <Link className="play-btn" to="#"><i className="icon-play-icon"></i></Link>
                              </div>
                              <div className="main-item d-md-none">
                                  <Link to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                                    {item.images.length > 2 ?
                                    (item.images[2].hd_url ? <img src={item.images[2].hd_url} alt={`${item.display_address}+  - Martyn Gerrard`}/> : <ImageTransform imagesources={item.images[2].url} renderer="srcSet" imagename="property.images.similar_properties" attr={{ alt: item.display_address+ ' - Martyn Gerrard', class:'' }} imagetransformresult={processedImages} id={item._id}/>) :
                                      <img loading="lazy" src={ComingSoonImage} alt={`${item.display_address} - Martyn Gerrard`} />
                                    }
                                  </Link>
                              </div>
                          </Slider>
                </div>
                      <Link className="card-details" to={'/'+uriStr+item.slug+'/'+item.crm_id?.toLowerCase()}>
                        <div className="detail-head d-flex align-items-center justify-content-between">
                            <h2 className="price">&pound;{item.price.toLocaleString()}</h2>
                            {/* <Link className="wishlist-icn" to="#"><i className="icon-heart"></i></Link> */}
                        </div> 
                        <span className="address-title d-block">{item.display_address}</span>
                        <span className="prop-title d-block">{item.title}</span>
                        {/* <div className="d-flex">
                            <span className="distance d-flex align-items-center"><i className="icon-station"></i> 0.4 miles</span>
                            <span className="distance d-flex align-items-center"><i className="icon-schools"></i> 0.63 miles</span>
                        </div> */}
                      </Link>
            </div>
            </motion.div>
            )})
            }
            </Slider> : 'No properties found'
            }
</>


    )

}

export default LetPropSlider;
